import _ from 'lodash'
import {MutationTree} from 'vuex'
import {CMSState} from '@/modules/cms/store'
import {Page, PageTranslation} from '@/modules/cms/types'

export enum MutationTypes {
    SetPages = 'page/list/set',
    DeletePage = 'page/list/delete',
    SetSyncPages = 'page/sync/set',
    SetLoadingPageList  = 'page/list/loading/set',
    SetCurrentPage = 'page/current/set',
    SetLoadingPage = 'page/loading/set',
    SetCurrentTranslation = 'page/current/translation/set',
    SetCurrentTranslationByLocale = 'page/current/translation/set-by-locale',
    SetSavingPage = 'page/saving/set',
    UpdateCurrentPageTranslationField = 'page/current/translation/field/update',
    SetPageToDelete = 'page/to-delete/set',
    TogglePagePreview = 'TOGGLE_PAGE_PREVIEW',
    TogglePagePreviewLoading = 'TOGGLE_PAGE_PREVIEW_LOADING',
    SetPagePreviewContent = 'SET_PAGE_PREVIEW_CONTENT',
    UpdateCurrentPageField = 'UPDATE_CURRENT_PAGE_FIELD',
}

const mutations: MutationTree<CMSState> = {
    /**
     * Registra la lista de páginas en el estado
     */
    [MutationTypes.SetPages]: (state, pages: Page[]) => state.pages = pages,

    /**
     * Establece si la aplicación esta actualmente sincronizando páginas
     */
    [MutationTypes.SetSyncPages]: (state, isSync: boolean) => state.syncPages = isSync,

    /**
     * Permite establecer si se esta ejecutado el proceso para obtener la lista de imágenes
     */
    [MutationTypes.SetLoadingPageList]: (state, isLoading: boolean) => state.loadingPageList = isLoading,

    /**
     * Permite establecer la página actual en edición
     */
    [MutationTypes.SetCurrentPage]: (state, page: Page) => state.currentPage = page,

    /**
     * Permite establecer si se esta ejecutando el proceso para obtener una página del sitio
     *
     * @param state
     * @param {boolean} loading
     * @returns {boolean}
     */
    [MutationTypes.SetLoadingPage]: (state, loading: boolean) => state.loadingPage = loading,

    /**
     * Establece la traducción de la página actualmente en edición
     */
    [MutationTypes.SetCurrentTranslation]: (state, translation: PageTranslation) => {
        state.currentTranslation = translation
    },

    [MutationTypes.SetCurrentTranslationByLocale]: (state, locale: string) => {
        state.currentTranslation = state.currentPage.translate(locale)
    },

    [MutationTypes.SetSavingPage]: (state, saving: boolean) => state.savingPage = saving,

    /**
     * Actualiza una campo de la traducción actualmente en edición
     */
    [MutationTypes.UpdateCurrentPageTranslationField]: (state, payload: {path: string, value: any}) => {
        _.set(state.currentTranslation, payload.path, payload.value)
    },

    /**
     * Establece la página que el usuario desea eliminar
     */
    [MutationTypes.SetPageToDelete]: (state, page: Page) => state.pageToDelete = page,

    /**
     * Elimina una página de la lista de páginas
     */
    [MutationTypes.DeletePage]: (state, id: number) => {
        const index = state.pages.findIndex(p => p.id === id)
        if (index === -1) {
            throw new Error(`No existe la página con id ${id}`)
        }

        state.pages.splice(index, 1)
    },
    [MutationTypes.TogglePagePreview]: (state, show: boolean) => state.pagePreview = show,
    [MutationTypes.TogglePagePreviewLoading]: (state, loading: boolean) => state.loadingPagePreview = loading,
    [MutationTypes.SetPagePreviewContent]: (state, content: string) => state.pagePreviewContent = content,
    [MutationTypes.UpdateCurrentPageField]: (state, payload: {field: string, value: any}) => {
        _.set(state.currentPage, payload.field, payload.value)
    },
}

export default mutations
